import React from 'react'
import './Jobs.css'


let JobsList = [
  { title: 'University Information Technology Services - Indiana University ', position: 'UX Designer', date: ' August 2025 – Current', location: 'Bloomington, IN', des: ['Interviewed teams across IU to assess Confluence usage, identifying unused features, migration risks, and must-have requirements for a replacement platform; authored a findings report and executive summary delivered to the VP for Information Technology.', ' Ran 50+ usability testing sessions across 4 cross-functional projects — including a student cost calculator, gateway site navigation, and an AI research-matching platform — partnering with marketing, finance, and software engineering teams', 'Redesigned content for satellite campus library pages as one of 3 designers on a 30+ page project; the redesign is live.', 'Architected content structure for Indiana University Southeast school pages as one of 3 designers consolidating 6 schools into 3 while preserving degree program availability; currently in development.'] },

  { title: 'Indiana Geological and Water Survey -  Indiana University ', position: 'Data Specialist (Contract)', date: 'August 2024 – January 2026', location: 'Bloomington, IN', des: ['Digitized 200,000+ handwritten water well logs for the Indiana DNR into a structured SQL database as part of a 3-person contracted team, personally completing 50%+ of total volume and replacing a fully manual process by sourcing, testing, and integrating AI vision APIs (OpenAI, Google Cloud Vision, Azure AI).', 'Selected Google AI Vision API based on accuracy-to-cost comparison; built a Python pipeline to extract text from scanned logs, clean the output, and sort records into the database.', ' Designed an adaptive database schema and lookup table system to standardize inconsistent well log formats while maintaining compliance with data transparency laws requiring non-form driller data to remain accessible.', 'Designed QA/QC procedures enforcing a confidence-based review threshold (manual review below 80% confidence), executed in partnership with a teammate responsible for verification — maintaining accuracy as automated extraction confidence improved to ~90% average over 2 years.'] },

  { title: 'Buffalouies Inc', position: 'Information Systems Designer', date: 'August 2023 – October 2025', location: 'Bloomington, Indiana', des: ['Designed menu boards to elevate customer experience and maximize sales based on strategic planning.', 'Customized restaurant ordering interface to improve accessibility and usability for online orders.', 'Evaluate and redesign the current dine-in ordering process (via kiosk, tablet, or app) to enhance usability, and overall user satisfaction'] }
];

const Jobs = () => {
  return (
    <div>
      {JobsList.map((jobPosition, index) => (
        <div key={index} className="JobCard">
          <div className='JobTitle-Dates'>

            <div >
              <h3>{jobPosition.position}</h3>
              <p >{jobPosition.title}</p>
            </div>
            <div>
              <p className='top-line-resume'>{jobPosition.location}</p>
              <p>{jobPosition.date} </p>


            </div>
          </div>

          <ul className='jobs-description-list'>
            {jobPosition.des.map((point, i) => (
              <li key={i}>{point}</li>
            ))}

          </ul>
        </div>

      ))}
    </div>
  )
}

export default Jobs